import * as React from 'react';
import { ReactComponent as SkiGptLockup } from 'public/assets/skigpt-logo-horz.svg';
import { cn } from '@/util/cn';

// SkiGptLogo — the real SkiGPT brand lockup, vendored from the chat app
// (chat.onthesnow.com/assets/skigpt-logo-horz.svg) so the on-site promotions
// render the actual logo instead of re-typing the wordmark in HTML.
//
// Three things to know before reaching for it:
//
//  - It already contains the snowflake, so don't pair it with <SnowMark>.
//  - Its fills are the fixed brand colours (#13B5EA / #0079C1) rather than
//    `currentColor`, so `text-*` utilities won't tint it. Keep it on white or
//    a very light surface.
//  - Size it by height and let the 182:41 viewBox carry the width. `h-5` is
//    the promo-chip default; `h-4` is where the letterforms start to mush,
//    because the wordmark only fills ~53% of the box height — the snowflake
//    is what reaches the edges — so the box always runs taller than the
//    letters it has to carry.
//
// The artwork is hidden from the accessibility tree and paired with an
// sr-only wordmark, so the brand name stays real text for screen readers and
// crawlers the way the hand-built markup it replaced did.

type Props = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

export const SkiGptLogo = ({ className, ...props }: Props) => (
  <>
    <SkiGptLockup
      className={cn('w-auto', className)}
      focusable="false"
      aria-hidden
      {...props}
    />
    <span className="sr-only">SkiGPT</span>
  </>
);
